import React from 'react';
import Alert from '@material-ui/lab/Alert';
import SnackbarComponent from '@material-ui/core/Snackbar';
import PropTypes from 'prop-types';

const AlertSnackbar = ({ action, customization: { type }, message, ...snackbarProps }) => (
    <SnackbarComponent { ...snackbarProps }>
        <Alert variant="standard" severity={ type } action={ action }>
            { message }
        </Alert>
    </SnackbarComponent>
);

AlertSnackbar.propTypes = {
    action: PropTypes.element,
    customization: PropTypes.shape({
        type: PropTypes.string,
    }),
    message: PropTypes.string,
};

export default AlertSnackbar;
